import { cn } from '@/lib/cn.js';

export interface ContractLogoData {
  tag: string; // 2-letter monogram
  color: string; // hex
}

export interface ContractLogoProps {
  contract: ContractLogoData;
  size?: number;
  square?: boolean;
}

export function ContractLogo({
  contract,
  size = 24,
  square = true,
}: ContractLogoProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center font-bold tracking-tight text-ink-900 shrink-0',
        square ? 'rounded-[5px]' : 'rounded-full'
      )}
      style={{
        width: size,
        height: size,
        background: contract.color,
        fontSize: Math.max(10, size * 0.42),
      }}
      aria-hidden="true"
    >
      {contract.tag}
    </span>
  );
}
